import { BrowserRouter, Route, Routes, Navigate, useLocation } from "react-router-dom";
import { useEffect } from "react";

import { Footer } from "./components/footer";
import { Player } from "./pages/player";

import "./style/defaults/variables.css";
import "./style/defaults/page-setup.css";
import "./style/defaults/transitions.css";

export default function App() {
  return (
    <>
      <BrowserRouter>
        <ScrollToTop />

        <Routes>
          <Route path="/" element={<Navigate to="/station/radio-promil" />} />
          <Route path="station/radio-promil" element={<Player
            station="Radio Promil"
            audioUrl="https://admin.radiopromil.online/radio/8000/radio.m4a"
            apiUrl="https://admin.radiopromil.online/api/nowplaying_static/radio_promil.json"
            apiHistoryUrl="https://admin.radiopromil.online/api/nowplaying_static/radio_promil.json"
            apiTimetableUrl="https://admin.radiopromil.online/api/station/radio_promil/schedule?rows=100"
          />} />
        </Routes>
        <Footer />
      </BrowserRouter>
    </>
  );
}

function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}
